export const FOLLOWED_FUNDS_QUERY_PREFIX = ['followed-funds'] as const;
export const FOLLOWING_FIC_DASHBOARD_SUMMARY_QUERY_PREFIX = [
  'following-fic-dashboard-summary',
] as const;

export function followedFundsQueryKey(userId: number | null | undefined) {
  return [...FOLLOWED_FUNDS_QUERY_PREFIX, userId ?? null] as const;
}

export function followingFicDashboardSummaryQueryKey(
  userId: number | null | undefined,
  indicatorsCompetencyDate: string,
) {
  return [
    ...FOLLOWING_FIC_DASHBOARD_SUMMARY_QUERY_PREFIX,
    userId ?? null,
    indicatorsCompetencyDate,
  ] as const;
}
